// src/components/ui/Eyebrow.tsx — italic serif menu label.
import type { CSSProperties, ReactNode } from "react";
import { C, F } from "../../theme";

export interface EyebrowProps {
  children: ReactNode;
  c?: string;
  style?: CSSProperties;
}

export const Eyebrow = ({ children, c = C.brassDk, style }: EyebrowProps) => (
  <div
    style={{
      fontFamily: F.serif,
      fontStyle: "italic",
      fontSize: 13,
      fontWeight: 600,
      color: c,
      letterSpacing: 0.2,
      ...style,
    }}
  >
    {children}
  </div>
);
